// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Wgt4k9b8PTUpxEI1EwxWq","items":"_2ciFLPEmJK4lTpUolqB51a","group":"_3VBHinjyhOxStbIOZ26Y6R","arrows":"_2Cy8EbPRjDXYDdfz8f9QuL","reverse":"_3LI2N9bEX0DO62jN6y44zI"};